import type { ChartRows } from "@/lib/tool-kit/games-organizers/t-chart";

/** The T: a heading row over two columns, with rows that share the sheet's height. */
export default function TChartSheet({
  title,
  leftHeading,
  rightHeading,
  rows,
  numbered,
  nameLine,
  nameLabel,
  dateLabel,
  ratio,
  label,
}: {
  title: string;
  leftHeading: string;
  rightHeading: string;
  rows: ChartRows;
  numbered: boolean;
  nameLine: boolean;
  nameLabel: string;
  dateLabel: string;
  ratio: number;
  label: string;
}) {
  return (
    <section
      aria-label={label}
      className="ws-sheet mx-auto w-full rounded-sm border border-border bg-white p-4 text-neutral-900 shadow-sm sm:p-8"
    >
      <div className="mb-3 flex flex-wrap items-end justify-between gap-x-8 gap-y-2">
        <p className="min-h-[1.75rem] font-semibold text-lg">{title}</p>
        {nameLine ? (
          <div className="flex gap-6 text-sm">
            <span className="flex items-end gap-2">
              {nameLabel}
              <span className="inline-block w-48 border-neutral-900 border-b" />
            </span>
            <span className="flex items-end gap-2">
              {dateLabel}
              <span className="inline-block w-28 border-neutral-900 border-b" />
            </span>
          </div>
        ) : null}
      </div>
      <div
        className="flex flex-col border-2 border-neutral-800"
        style={{ aspectRatio: ratio }}
      >
        <div className="grid grid-cols-2 border-neutral-800 border-b-2 text-center font-bold text-lg sm:text-2xl">
          <p className="border-neutral-800 border-r-2 px-2 py-2">
            {leftHeading}
          </p>
          <p className="px-2 py-2">{rightHeading}</p>
        </div>
        {Array.from({ length: rows.count }, (_, i) => (
          <div
            className="grid min-h-0 flex-1 grid-cols-2 overflow-hidden border-neutral-400 border-b text-sm leading-tight last:border-b-0"
            // biome-ignore lint/suspicious/noArrayIndexKey: rows are positional
            key={i}
          >
            <p className="flex items-center gap-2 overflow-hidden border-neutral-800 border-r-2 px-2">
              {numbered ? (
                <span className="text-neutral-500 text-xs">{i + 1}</span>
              ) : null}
              <span>{rows.left[i] ?? ""}</span>
            </p>
            <p className="flex items-center gap-2 overflow-hidden px-2">
              {numbered ? (
                <span className="text-neutral-500 text-xs">{i + 1}</span>
              ) : null}
              <span>{rows.right[i] ?? ""}</span>
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
